import actionTypes from '../common/actionTypes';
import reportAPI from './reportAPI';

const reportActions = {
	fetchCustomersCount: () => (dispatch: any) => {
		return reportAPI.fetchCustomersCount()
			.then(customersCount => {
				dispatch({ type: actionTypes.FETCH_CUSTOMERS_COUNT, customersCount });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchUserActivities: (fromDate: string, toDate: string) => (dispatch: any) => {
		return reportAPI.fetchUserActivities(fromDate, toDate)
			.then(users => {
				dispatch({ type: actionTypes.FETCH_USER_ACTIVITIES, users });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchPoliciesCount: () => (dispatch: any) => {
		return reportAPI.fetchPoliciesCount()
			.then(policiesCount => {
				dispatch({ type: actionTypes.FETCH_POLICIES_COUNT, policiesCount });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchPolicies: () => (dispatch: any) => {
		return reportAPI.fetchPolicies()
			.then(policies => {
				dispatch({ type: actionTypes.FETCH_POLICIES, policies });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchUnmailedPoliciesCount: () => (dispatch: any) => {
		return reportAPI.fetchUnmailedPoliciesCount()
			.then(unmailedPoliciesCount => {
				dispatch({ type: actionTypes.FETCH_UNMAILED_POLICIES_COUNT, unmailedPoliciesCount });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchUnmailedPolicies: () => (dispatch: any) => {
		return reportAPI.fetchUnmailedPolicies()
			.then(unmailedPolicies => {
				dispatch({ type: actionTypes.FETCH_UNMAILED_POLICIES, unmailedPolicies });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchFailedPaymentsCount: () => (dispatch: any) => {
		return reportAPI.fetchFailedPaymentsCount()
			.then(failedPaymentsCount => {
				dispatch({ type: actionTypes.FETCH_FAILED_PAYMENTS_COUNT, failedPaymentsCount });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchFailedPayments: () => (dispatch: any) => {
		return reportAPI.fetchFailedPayments()
			.then(failedPayments => {
				dispatch({ type: actionTypes.FETCH_FAILED_PAYMENTS, failedPayments });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchExpiringPoliciesCount: () => (dispatch: any) => {
		return reportAPI.fetchExpiringPoliciesCount()
			.then(expiringPoliciesCount => {
				dispatch({ type: actionTypes.FETCH_EXPIRING_POLICIES_COUNT, expiringPoliciesCount });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchExpiringPolicies: () => (dispatch: any) => {
		return reportAPI.fetchExpiringPolicies()
			.then(expiringPolicies => {
				dispatch({ type: actionTypes.FETCH_EXPIRING_POLICIES, expiringPolicies });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchMissingBeneficiaryFormsCount: () => (dispatch: any) => {
		return reportAPI.fetchMissingBeneficiaryFormsCount()
			.then(missingBeneficiaryFormsCount => {
				dispatch({ type: actionTypes.FETCH_MISSING_BENEFICIARY_FORMS_COUNT, missingBeneficiaryFormsCount });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchCustomersMissingBeneficiaryForms: () => (dispatch: any) => {
		return reportAPI.fetchCustomersMissingBeneficiaryForms()
			.then(customers => {
				dispatch({ type: actionTypes.FETCH_CUSTOMERS_MISSING_BENEFICIARY_FORMS, customers });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchBouncedEmailsCount: () => (dispatch: any) => {
		return reportAPI.fetchBouncedEmailsCount()
			.then(bouncedEmailsCount => {
				dispatch({ type: actionTypes.FETCH_BOUNCED_EMAILS_COUNT, bouncedEmailsCount });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchBouncedEmails: () => (dispatch: any) => {
		return reportAPI.fetchBouncedEmails()
			.then(bouncedEmails => {
				dispatch({ type: actionTypes.FETCH_BOUNCED_EMAILS, bouncedEmails });
			})
			.catch(err => {
				throw err;
			});
	},
	resolveBouncedEmail: (id: string) => (dispatch: any) => {
		return reportAPI.resolveBouncedEmail(id)
			.then(bouncedEmail => {
				dispatch({ type: actionTypes.RESOLVE_BOUNCED_EMAIL, bouncedEmail });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchFinancialExport: (fromDate: string, toDate: string) => (dispatch: any) => {
		return reportAPI.fetchFinancialExport(fromDate, toDate)
			.then(financials => {
				dispatch({ type: actionTypes.FETCH_FINANCIAL_REPORT, financials });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchReferralReport: () => (dispatch: any) => {
		return reportAPI.fetchReferralReport()
			.then(referrals => {
				dispatch({ type: actionTypes.FETCH_REFERRALS, referrals });
			})
			.catch(err => {
				throw err;
			});
	},
};

export default reportActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/report/reportActions.ts